import React from "react";
import { View } from '../../../components/templates/View';
import { CDMantenimientoIndustrial, CMMantenimientoIndustrial } from '../organisms';
import { useViewport } from "../../../hooks";

const MantenimientoIndustrial = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDMantenimientoIndustrial /> }/>
            </>
        :
            <>
                <View children={ <CMMantenimientoIndustrial/> }/>
            </>
    );
}

export default MantenimientoIndustrial;

